import { useState, useRef } from "react";
import DotsIcon from "../../../assets/icons/dots";
import { useOutsideClick } from "../../../hooks/outsideClick";
import AppPortal from "../../AppPortal";
import "./ApiKeysDotsModal.css";

interface ApiKeysDotsModalProps {
  onEditClick?: (key: string) => void;
  onDeleteClick?: (key: string) => void;
  onRequestProductionClick?: () => void;
  appKey?: string | undefined;
  platform?: boolean;
}

const ApiKeysDotsModal: React.FC<ApiKeysDotsModalProps> = ({
  onEditClick,
  onDeleteClick,
  onRequestProductionClick,
  appKey,
  platform = false,
}) => {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const dropdownRef = useRef<HTMLUListElement | null>(null);

  const toggleDropdown = () => {
    if (!open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY - 30,
        left: rect.left + window.scrollX - 210,
      });
    }
    setOpen((prev) => !prev);
  };

  useOutsideClick(dropdownRef, () => {
    if (open) setOpen(false);
  });

  const dropdown = (
    <ul
      ref={dropdownRef}
      className="dropdown-container"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        position: "absolute",
        zIndex: 9999,
      }}
    >
      <li
        onClick={() => {
          if (onEditClick && appKey) {
            onEditClick(appKey);
            setOpen(false);
          }
        }}
      >
        Update {platform ? "Platform" : "App"} Details
      </li>
      {!platform && (
        <li
          onClick={() => {
            onRequestProductionClick?.();
            setOpen(false);
          }}
        >
          Request Production
        </li>
      )}
      <li
        onClick={() => {
          if (onDeleteClick && appKey) {
            onDeleteClick(appKey);
            setOpen(false);
          }
        }}
      >
        Delete {platform ? "Platform" : "App"}
      </li>
    </ul>
  );

  return (
    <>
      <div className="dots-dropdown">
        <button
          ref={buttonRef}
          className="dots-button"
          onClick={toggleDropdown}
          aria-label="Options"
        >
          <DotsIcon />
        </button>
      </div>

      {open && <AppPortal>{dropdown}</AppPortal>}
    </>
  );
};

export default ApiKeysDotsModal;
